import React, { useState, useEffect, useCallback } from "react";
import "../static/css/AdminGallery.css";
import axios from "axios";

function AdminGallery() {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [activeTab, setActiveTab] = useState("Anniversary");
  const [file, setFile] = useState(null);
  const [items, setItems] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);

  const fetchItems = useCallback(async () => {
    try {
      let endpoint = "";
      if (activeTab === "Anniversary") {
        endpoint = "https://skpbackend.quindl.com/gallery/anniversary/admin";
      } else if (activeTab === "Seminar") {
        endpoint = "https://skpbackend.quindl.com/gallery/seminar";
      } else if (activeTab === "Award") {
        endpoint = "https://skpbackend.quindl.com/gallery/award";
      }
      const response = await axios.get(endpoint);
      setItems(response.data);
    } catch (error) {
      console.error("Error fetching gallery items:", error);
    }
  }, [activeTab]);

  useEffect(() => {
    fetchItems();
  }, [fetchItems]);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      try {
        let endpoint = "";
        if (activeTab === "Anniversary") {
          endpoint = `https://skpbackend.quindl.com/gallery/anniversary/${id}`;
        } else if (activeTab === "Seminar") {
          endpoint = `https://skpbackend.quindl.com/gallery/seminar/${id}`;
        } else if (activeTab === "Award") {
          endpoint = `https://skpbackend.quindl.com/gallery/award/${id}`;
        }
        await axios.delete(endpoint);
        alert("Item deleted successfully");
        fetchItems();
      } catch (error) {
        console.error("Error deleting item:", error);
        alert("Failed to delete item");
      }
    }
  };

  const handleEdit = (item) => {
    setIsEditing(true);
    setEditId(item.id);
    setTitle(item.title || item.year);
    setContent(item.content || "");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const resetForm = () => {
    setTitle("");
    setContent("");
    setFile(null);
    setIsEditing(false);
    setEditId(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file && !isEditing) {
      alert("Please select a file");
      return;
    }

    const formData = new FormData();
    if (file) {
      formData.append("image", file);
    }

    let endpoint = "";
    const method = isEditing ? "put" : "post";

    if (activeTab === "Anniversary") {
      formData.append("year", title);
      endpoint = isEditing 
        ? `https://skpbackend.quindl.com/gallery/anniversary/${editId}`
        : "https://skpbackend.quindl.com/gallery/anniversary";
    } else {
      formData.append("title", title);
      formData.append("content", content);
      if (activeTab === "Seminar") {
        endpoint = isEditing
          ? `https://skpbackend.quindl.com/gallery/seminar/${editId}`
          : "https://skpbackend.quindl.com/gallery/seminar";
      } else if (activeTab === "Award") {
        endpoint = isEditing
          ? `https://skpbackend.quindl.com/gallery/award/${editId}`
          : "https://skpbackend.quindl.com/gallery/award";
      }
    }

    try {
      await axios({
        method: method,
        url: endpoint,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      alert(`Item ${isEditing ? "updated" : "added"} successfully`);
      resetForm();
      fetchItems();
    } catch (error) {
      console.error("There was an error updating the file!", error);
      alert(`${isEditing ? "Update" : "Upload"} failed`);
    }
  };

  return (
    <div className="admin-gallery-page">
      <div className="Admincontrol">
        <div className="admincontrol-form">
          <div className="gallery-tabs">
            {["Anniversary", "Seminar", "Award"].map((tab) => (
              <button
                key={tab}
                className={activeTab === tab ? "active" : ""}
                onClick={() => {
                  setActiveTab(tab);
                  resetForm(); // Reset form when switching tabs to avoid confusion
                }}
              >
                {tab}
              </button>
            ))}
          </div>
          <form onSubmit={handleSubmit} className="gallery-form">
            <label htmlFor="title">
              {activeTab === "Anniversary" ? "Year" : activeTab === "Seminar" ? "Seminar Name" : "Award Name"}
            </label>
            <input
              id="title"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder={`Enter ${activeTab === "Anniversary" ? "year" : "name"}`}
            />

            {activeTab !== "Anniversary" && (
              <>
                <label htmlFor="content">
                  {activeTab === "Seminar" ? "Seminar Description" : "Award Description"}
                </label>
                <input
                  id="content"
                  type="text"
                  value={content}
                  onChange={(e) => setContent(e.target.value)}
                  placeholder="Enter description"
                />
              </>
            )}

            <label htmlFor="file">Upload Image</label>
            <input id="file" type="file" onChange={handleFileChange} />
            
            <button type="submit" className="submit-btn">
              {isEditing ? "Update Item" : "Submit"}
            </button>
            {isEditing && (
              <button type="button" onClick={resetForm} className="cancel-btn">
                Cancel Edit
              </button>
            )}
          </form>
        </div>

        <div className="gallery-list-container">
            <h3>{activeTab} Gallery Items</h3>
            <div className="items-grid">
                {items.map((item) => (
                    <div key={item.id} className="gallery-item">
                        <img 
                          src={`https://skpbackend.quindl.com${item.location}`} 
                          alt={item.title || item.year} 
                        />
                        <h4>{item.title || item.year}</h4>
                        {item.content && <p>{item.content}</p>}
                        <div className="item-actions">
                          <button className="edit-btn" onClick={() => handleEdit(item)}>Edit</button>
                          <button className="delete-btn" onClick={() => handleDelete(item.id)}>Delete</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
      </div>
    </div>
  );
}

export default AdminGallery;